"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _switch = _interopRequireDefault(require("../switch"));

var _create = _interopRequireDefault(require("../utils/create"));

var _default = (0, _create.default)({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('cell', {
      class: _vm.b(),
      attrs: {
        "center": "",
        "title": _vm.title,
        "border": _vm.border
      }
    }, [_c('van-switch', _vm._b({
      on: {
        "input": function input($event) {
          _vm.$emit('input', $event);
        }
      }
    }, 'van-switch', _vm.$props, false))], 1);
  },
  name: 'switch-cell',
  components: {
    VanSwitch: _switch.default
  },
  props: {
    title: String,
    value: Boolean,
    border: Boolean,
    loading: Boolean,
    disabled: Boolean,
    activeColor: String,
    inactiveColor: String,
    size: {
      type: String,
      default: '24px'
    }
  },
  watch: {
    value: function value() {
      this.$emit('change', this.value);
    }
  }
});

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/switch-cell/index.js
// module id = 259
// module chunks = 1